// src/components/Admin/QuestionsContainer.js
import React, { useState } from 'react';
import AnswerQuestionModal from '../Modals/AnswerQuestionModal';
import QuestionsList from './QuestionsList';

const QuestionsContainer = ({
  questions,
  renderDesktopRow,
  renderMobileCard,
  tableHead,
  hidePendingToggle // Added this prop
}) => {
  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [selectedDetail, setSelectedDetail] = useState('');
  const [activePopupId, setActivePopupId] = useState(null);

  const handleReplyClick = (questionText, detail) => {
    setSelectedQuestion(questionText);
    setSelectedDetail(detail);
    setShowAnswerModal(true);
    setActivePopupId(null);
  };

  const handlePopupToggle = (id) => {
    setActivePopupId((prev) => (prev === id ? null : id));
  };

  const handleCloseModal = () => setShowAnswerModal(false);
  const handleSubmitAnswer = (event) => {
    event.preventDefault();
    // Answer submission logic…
    setShowAnswerModal(false);
  };

  // Shared actions passed to the row renderers.
  const actions = {
    handleReplyClick,
    activePopupId,
    handlePopupToggle,
  };

  return (
    <>
      <QuestionsList
        questions={questions}
        renderDesktopRow={(q, index) => renderDesktopRow(q, index, actions)}
        renderMobileCard={(q) => renderMobileCard(q, actions)}
        tableHead={tableHead}
        hidePendingToggle={hidePendingToggle}  // Forward the prop here
      />
      {showAnswerModal && (
        <AnswerQuestionModal
          questionId={selectedQuestion._id} // Ensure the question ID is passed here
          question={selectedQuestion}
          detail={selectedDetail}
          onClose={handleCloseModal}
          onSubmit={handleSubmitAnswer}
        />
      )}
    </>
  );
};

export default QuestionsContainer;
